import classNames from 'classnames';
import React, { useEffect, useState, useRef } from 'react';
import { HtmlContent } from '../../../../../utils';

import styles from '../../styles/loyalty_program.module.scss';

const INFO_LINES_COUNT = 3;

export const Description = ({ info }) => {
  const [isShowDetail, setIsShowDetail] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);
  const debounceRef = useRef(false);

  const handleTruncated = () => {
    const element = textRef.current;
    const lineHeight = parseInt(getComputedStyle(element).lineHeight, 10);
    const maxHeight = lineHeight * INFO_LINES_COUNT;
    setIsTruncated(element.scrollHeight > maxHeight);
    debounceRef.current = false;
  };

  const handleDebouncedTruncated = () => {
    if (textRef.current && debounceRef.current === false) {
      debounceRef.current = true;
      setTimeout(() => {
        handleTruncated();
      }, 500);
    }
  };

  useEffect(() => {
    handleTruncated();
  }, [info]);

  useEffect(() => {
    window.addEventListener('resize', handleDebouncedTruncated);

    return () => {
      window.removeEventListener('resize', handleDebouncedTruncated);
    };
  }, []);

  const handleShowDetail = () => setIsShowDetail(!isShowDetail);

  return (
    <div
      className={classNames({
        [styles.loyalty__description]: true,
        [styles.loyalty__description_collapsed]: !isShowDetail,
      })}
    >
      <HtmlContent ref={textRef} content={info} />
      {isTruncated && (
        <button
          className={styles.loyalty__description_btn}
          onClick={handleShowDetail}
        >
          {isShowDetail ? 'Свернуть' : 'Подробнее...'}
        </button>
      )}
    </div>
  );
};
